import * as types from '../_actions/actionTypes'
import _ from 'lodash'
import { normalize } from 'normalizr'
import { eventSchema } from './../entities/schema'
import { reports } from '../components/reporting/constants'
import dates from 'react-big-calendar/lib/utils/dates'
import moment from 'moment'

const eventListSchema = [eventSchema]

const selectedEmployee = ''
const _displayEvents = []
const _displayWorkEvents = []
const _displayAbsenceEvents = []
const _weeklyEvents = []
const _dailyEvents = []
const _employeeList = []
const _displayEmployees = []
const _displayEmployeesReport = []

const NORMALWORKING_ACTION = 99

export function roster(
    state = {
        loadingEmpoyeeList: true,
        loadingEvents: true,
        currentDate: new Date(),
        currentWeekDate: new Date(),
        events: {},
        displayEvents: {},
        employeeList: _employeeList,
        displayEmployees: _displayEmployees,
        displayEmployeesLeaveRpt: _displayEmployees,
        selectedEmployee: selectedEmployee,
        selectedBranches: [],
        selectedDepartments: [],
        selectedEmployees: [],
        hasActiveDateRangeFilter: false,
        displayWorkEvents: _displayWorkEvents,
        displayAbsenceEvents: _displayAbsenceEvents,
        displayWeeklyReportEvents: _weeklyEvents,
        displayDailyReportEvents: _dailyEvents,
        displayAbsenceReportEvents: _displayAbsenceEvents,
        displaySummaryReportEvents: [],
        displayEmployeesReport: _displayEmployeesReport,
        editMode: false,
    },
    action
) {
    switch (action.type) {
        case types.UPDATE_CURRENT_DATE:
            return _.merge({}, state, {
                currentDate: action.payload.currentDate,
            })
        case types.UPDATE_CURRENT_WEEK_DATE:
            return _.merge({}, state, {
                currentWeekDate: action.payload.currentWeekDate,
            })
        case types.FETCH_ROSTER_USER_ETIME:
            // const workEvents = filterWorkAbsenceEvents(
            //     action.payload.events,
            //     state,
            //     'work'
            // )
            // const normalizedWorkEvents = normalize(
            //     workEvents.filteredEvents,
            //     eventListSchema
            // )

            // const absenceEvents = filterWorkAbsenceEvents(
            //     action.payload.events,
            //     state,
            //     'absence'
            // )

            // const normalizedAbsenceEvents = normalize(
            //     absenceEvents.filteredEvents,
            //     eventListSchema
            // )

            return {
                ...state,
                ...action.payload,
                displayEvents: action.payload.events,
                loadingEvents: false,
            }
        // return _.merge({}, state, action.payload, {
        //     displayEvents: action.payload.events,
        //     loadingEvents: false,
        // })

        case types.FETCH_UPDATE_ROSTER_USER_ETIME: {
            if (state.selectedEmployee !== '') {
                const evts = filterDisplayEventsByEmp(
                    state.selectedEmployee,
                    action.payload.events,
                    state
                )

                const normalizedDisplayEvents = normalize(
                    evts,

                    eventListSchema
                )

                return _.merge({}, state, action.payload, {
                    displayEvents: normalizedDisplayEvents.entities.events,
                })
            }
            return _.merge({}, state, action.payload, {
                displayEvents: action.payload.events,
            })
        }
        case types.TRANSFORM_SUMMARY_RPT_DISPLAY_ETIME: {
            return _.merge({}, state, action.payload, {
                displayWorkEvents: action.payload.events,
            })
        }
        case types.UPDATE_WORK_EVENTS: {
            return Object.assign({}, state, {
                displayWorkEvents: action.payload.events,
            })
        }
        case types.UPDATE_WORK_EVENTS_FAILURE: {
            return state
        }
        case types.UPDATE_ABSENCE_EVENTS: {
            return _.merge({}, state, action.payload, {
                displayAbsenceEvents: action.payload.events,
            })
        }
        case types.UPDATE_WEEK_EVENTS: {
            return _.merge({}, state, action.payload, {
                displayWorkEvents: action.payload.events,
            })
        }
        case types.UPDATE_ROSTER_ETIME:
            const workEvt = filterWorkAbsenceEvents(
                action.payload.events,
                state,
                'work'
            )
            const normalizedWorkEvt = normalize(
                workEvt.filteredEvents,
                eventListSchema
            )

            const absenceEvt = filterWorkAbsenceEvents(
                action.payload.events,
                state,
                'absence'
            )

            const normalizedAbsenceEvt = normalize(
                absenceEvt.filteredEvents,
                eventListSchema
            )

            return _.merge({}, state, action.payload, {
                displayEvents: action.payload.events,
                displayWorkEvents: normalizedWorkEvt.entities.events,
                displayAbsenceEvents: normalizedAbsenceEvt.entities.events,
                displayWeeklyReportEvents: normalizedWorkEvt.entities.events,
                displayDailyReportEvents: normalizedWorkEvt.entities.events,
                displayAbsenceReportEvents:
                    normalizedAbsenceEvt.entities.events,
            })
        case types.UPDATE_DISPLAY_ETIME: {
            const employeeId = action.cond.employeeId
            let newState = null
            if (employeeId !== '' && employeeId !== undefined) {
                newState = filterDisplayEventsByEmp(
                    employeeId,
                    state.events,
                    state
                )
            } else {
                newState = updateDisplayEvents(action.cond, state)
            }

            const normalizedData = normalize(newState, eventListSchema)

            return Object.assign({}, state, {
                displayEvents: normalizedData.entities.events,
                selectedEmployee:
                    newState.selectedEmployee === ''
                        ? newState.selectedEmployee
                        : state.selectedEmployee,
            })
        }
        case types.UPDATE_DISPLAY_ROSTER: {
            return Object.assign({}, state, {
                displayEvents: action.cond.displayEvents,
            })
        }
        // case types.UPDATE_DISPLAY_ROSTER: {
        //     const employees = action.cond.employees
        //     let displayEvts = []
        //     if (!_.isEmpty(employees)) {
        //         displayEvts = filterDisplayEventsByEmployees(
        //             action.cond,
        //             state.events
        //         )
        //     }

        //     const normalizedData = normalize(displayEvts, eventListSchema)
        //     return Object.assign({}, state, {
        //         displayEvents: normalizedData.entities.events,
        //         selectedEmployees: employees,
        //     })
        // }
        // update summary report events
        case types.UPDATE_SUMMARY_REPORT_EVENTS: {
            const displayEvents = transformSummaryEvents(
                action.payload.events,
                action.options
            )

            return {
                ...state,
                ...action.payload,
                displaySummaryReportEvents: displayEvents,
            }
            // return _.merge({}, state, action.payload, {
            //   displaySummaryReportEvents: displayEvents
            // });
        }
        case types.UPDATE_WAVIEW_DISPLAY_ETIME: {
            const newState = filterDisplayEvents(action.cond, state)
            const normalizedData = normalize(newState, eventListSchema)

            if (action.cond.view === 'work') {
                return Object.assign({}, state, {
                    displayWorkEvents: normalizedData.entities.events,
                })
            } else {
                return Object.assign({}, state, {
                    displayAbsenceEvents: normalizedData.entities.events,
                })
            }
        }
        case types.UPDATE_WEEKLY_REPORT_EVENTS: {
            return _.merge({}, state, action.payload, {
                displayWeeklyReportEvents: action.payload.events,
            })
        }

        case types.UPDATE_WEEKLY_RPT_DISPLAY_ETIME: {
            const newState = updateRptDisplayEvents(action.cond, state)
            const normalizedData = normalize(newState, eventListSchema)

            return Object.assign({}, state, {
                displayWeeklyReportEvents: normalizedData.entities.events,
            })
        }
        case types.UPDATE_DAILY_RPT_DISPLAY_ETIME: {
            const newState = updateRptDisplayEvents(action.cond, state)
            const normalizedData = normalize(newState, eventListSchema)

            return Object.assign({}, state, {
                displayDailyReportEvents: normalizedData.entities.events,
            })
        }
        case types.UPDATE_LEAVE_RPT_DISPLAY_ETIME: {
            const newState = updateRptDisplayEvents(action.cond, state)
            const normalizedData = normalize(newState, eventListSchema)

            return Object.assign({}, state, {
                displayAbsenceReportEvents: normalizedData.entities.events,
            })
        }
        case types.UPDATE_SUMMARY_RPT_DISPLAY_ETIME: {
            const { events } = state
            const { branch, department } = action.cond

            const filteredEvents = filterWithBranchDepart(
                branch,
                department,
                events
            )

            const displayEvents = transformSummaryEvents(
                filteredEvents,
                action.cond
            )

            return {
                ...state,
                ...action.payload,
                displaySummaryReportEvents: displayEvents,
            }
        }
        case types.UPDATE_DAILY_REPORT_EVENTS: {
            return Object.assign({}, state, {
                displayDailyReportEvents: action.payload.events,
            })
        }
        case types.UPDATE_LEAVE_REPORT_EVENTS: {
            return _.merge({}, state, action.payload, {
                displayAbsenceReportEvents: action.payload.events,
            })
        }
        case types.UPDATE_WORK_ABSENCE_EVENTS: {
            const { events } = state

            const workEvents = filterWorkAbsenceEvents(events, state, 'work')
            const absenceEvents = filterWorkAbsenceEvents(
                events,
                state,
                'absence'
            )
            const normalizedWorkEvents = normalize(
                workEvents.filteredEvents,
                eventListSchema
            )
            const normalizedAbsenceEvents = normalize(
                absenceEvents.filteredEvents,
                eventListSchema
            )

            return Object.assign({}, state, {
                displayWorkEvents: normalizedWorkEvents.entities.events,
                displayAbsenceEvents: normalizedAbsenceEvents.entities.events,
            })
        }
        case types.UPDATE_DISPLAY_EMPLOYEE:
            // const {
            //     selectedBranches,
            //     selectedDepartments,
            //     selectedEmployees,
            // } = state
            const {
                employeeList,
                selectedBranches,
                selectedDepartments,
            } = state
            const { EmployeeBranch, EmployeeDepartment } = action.cond
            let empList = []

            if (!_.isEmpty(EmployeeBranch)) {
                empList = _.filter(employeeList, function(o) {
                    return _.includes(EmployeeBranch, o.EmployeeBranch)
                })

                if (!_.isEmpty(selectedDepartments)) {
                    empList = _.filter(empList, function(o) {
                        return _.includes(
                            selectedDepartments,
                            o.EmployeeDepartment
                        )
                    })
                }
                return Object.assign({}, state, {
                    displayEmployees: empList,
                })
            }

            if (!_.isEmpty(EmployeeDepartment)) {
                empList = _.filter(employeeList, function(o) {
                    return _.includes(EmployeeDepartment, o.EmployeeDepartment)
                })

                if (!_.isEmpty(selectedBranches)) {
                    empList = _.filter(empList, function(o) {
                        return _.includes(selectedBranches, o.EmployeeBranch)
                    })
                }

                return Object.assign({}, state, {
                    displayEmployees: empList,
                })
            }

            return Object.assign({}, state, {
                displayEmployees: employeeList,
            })

        // const empList = updateDisplayEmployee(action.cond, state)
        // const newState = updateDisplayEvents(action.cond, state)
        // const normalizedData = normalize(newState, eventListSchema)

        // const { employeeId } = action.cond
        // const empList = updateDisplayEmployee(action.cond, state)

        // const selected = _.find(empList, { EmployeeID: employeeId })

        // if (!_.isEmpty(selected) && selectedEmployee === employeeId) {
        //     return Object.assign({}, state, {
        //         displayEmployees: empList,
        //     })
        // } else {
        //     const newState = updateDisplayEvents(action.cond, state)
        //     const normalizedData = normalize(newState, eventListSchema)
        //     return Object.assign({}, state, {
        //         displayEmployees: empList,
        //         displayEvents: normalizedData.entities.events,
        //         selectedEmployee: '',
        //     })
        // }

        case types.ADD_ROSTER_ETIME:
            return Object.assign({}, state, {
                events: addEvent(action.payload, state),
            })
        case types.REMOVE_ROSTER_ETIME:
            const removedEvents = removeEvent(action.payload, state)
            const omitState = _.omit(state, 'events', 'displayEvents')
            return {
                ...omitState,
                events: removedEvents,
                displayEvents: removedEvents,
            }
        case types.FETCH_ROSTER_USER_ETIME_FAILURE:
            return state
        case types.UPDATE_ROSTER_ETIME_FAILURE:
            return state
        case types.ADD_ROSTER_ETIME_FAILURE:
            return state
        case types.REMOVE_ROSTER_ETIME_FAILURE:
            return state
        case types.SELECT_EMPLOYEE:
            return Object.assign({}, state, {
                selectedEmployee: action.payload,
            })
        case types.SELECT_EMPLOYEES:
            return Object.assign({}, state, {
                selectedEmployees: action.payload,
            })
        case types.SELECT_BRANCHES:
            return Object.assign({}, state, {
                selectedBranches: action.payload,
            })
        case types.SELECT_DEPARTMENTS:
            return Object.assign({}, state, {
                selectedDepartments: action.payload,
            })
        case types.SELECT_DATE_RANGE_FILTER:
            return Object.assign({}, state, {
                startDate: action.payload.startDate,
                endDate: action.payload.endDate,
                hasActiveDateRangeFilter: action.payload.hasActive,
            })
        case types.FETCH_EMPLOYEE_LIST:
            // const empOption = action.payload.map(emp => {
            //     let o = {}
            //     o.name = emp.EmployeeName
            //     o.code = emp.key
            //     return o
            // })

            return Object.assign({}, state, {
                employeeList: action.payload,
                displayEmployees: action.payload,
                // selectedEmployees: empOption,
                displayEmployeesReport: action.payload,
                displayEmployeesLeaveRpt: action.payload,
                loadingEmpoyeeList: false,
            })
        case types.FETCH_EMPLOYEE_LIST_FAILURE:
            return Object.assign({}, state, {
                employeeList: _employeeList,
            })
        // case types.UPDATE_DISPLAY_EMPLOYEE:
        //     return Object.assign({}, state, {
        //         displayEmployees: updateDisplayEmployee(action.cond, state),
        //     })
        case types.UPDATE_DISPLAY_EMPLOYEE_LEAVERPT:
            return Object.assign({}, state, {
                displayEmployeesLeaveRpt: updateDisplayEmployee(
                    action.cond,
                    state
                ),
            })
        case types.FILTER_WEEKLY_REPORT_INFO: {
            const { EmployeeBranch, EmployeeDepartment, view } = action.cond
            let empFilterCond = {}
            if (EmployeeBranch !== undefined) {
                empFilterCond.EmployeeBranch = EmployeeBranch
            }
            if (EmployeeDepartment !== undefined) {
                empFilterCond.EmployeeDepartment = EmployeeDepartment
            }

            let emplist = updateDisplayEmployee(empFilterCond, state)

            let cond = {}
            cond.branch = EmployeeBranch
            cond.department = EmployeeDepartment
            cond.view = view

            return Object.assign({}, state, {
                displayEmployeesReport: emplist,
            })
        }
        case types.FILTER_DAILY_REPORT_INFO: {
            const { EmployeeBranch, EmployeeDepartment, view } = action.cond
            let empFilterCond = {}
            if (EmployeeBranch !== undefined) {
                empFilterCond.EmployeeBranch = EmployeeBranch
            }
            if (EmployeeDepartment !== undefined) {
                empFilterCond.EmployeeDepartment = EmployeeDepartment
            }

            let emplist = updateDisplayEmployee(empFilterCond, state)

            let cond = {}
            cond.branch = EmployeeBranch
            cond.department = EmployeeDepartment
            cond.view = view

            return Object.assign({}, state, {
                displayEmployeesReport: emplist,
            })
        }
        case types.SET_EDIT_MODE:
            return Object.assign({}, state, { editMode: action.payload })
        default:
            return state
    }
}

function filterWorkAbsenceEvents(data, state, viewType) {
    if (viewType === 'work') {
        const filteredEvents = _.filter(data, function(evt) {
            return evt.ActionType === NORMALWORKING_ACTION
        })

        _.sortBy(filteredEvents, ['start'])
        return {
            filteredEvents,
        }
    } else {
        const filteredEvents = _.filter(data, function(evt) {
            return evt.ActionType !== NORMALWORKING_ACTION
        })
        _.sortBy(filteredEvents, ['start'])
        return {
            filteredEvents,
        }
    }
}

/**
 *
 * @param {*} cond
 * @param {*} state
 */
function updateDisplayEmployee(cond, state) {
    const { employeeList } = state

    const _cond = Object.assign({}, cond)
    // delete _cond.employeeId

    const filteredEmployees = _.filter(employeeList, _cond)
    return filteredEmployees
}

/**
 * Filter by selected Branch and Department
 *
 * @param {*} cond
 * @param {*} state
 */
function updateDisplayEvents(cond, state) {
    const { events, selectedDepartments, selectedEmployees } = state

    const branches = cond

    const filteredEvents = _.filter(events, function(evt) {
        return evt
        // evt.Employee['EmployeeBranch'] === EmployeeBranch &&
        // evt.Employee['EmployeeDepartment'] === EmployeeDepartment
        //evt.EmployeeID = 164
    })

    return filteredEvents

    // const { EmployeeBranch, EmployeeDepartment } = cond

    // All branches and departments
    // if (EmployeeBranch === undefined && EmployeeDepartment === undefined) {
    //     return events
    // } else if (
    //     EmployeeBranch !== undefined &&
    //     EmployeeDepartment === undefined
    // ) {
    //     const filteredEvents = _.filter(events, function(evt) {
    //         return evt.Employee['EmployeeBranch'] === EmployeeBranch
    //     })
    //     return filteredEvents
    // } else if (
    //     EmployeeBranch === undefined &&
    //     EmployeeDepartment !== undefined
    // ) {
    //     const filteredEvents = _.filter(events, function(evt) {
    //         return evt.Employee['EmployeeDepartment'] === EmployeeDepartment
    //     })
    //     return filteredEvents
    // } else {
    //     const filteredEvents = _.filter(events, function(evt) {
    //         return (
    //             evt.Employee['EmployeeBranch'] === EmployeeBranch &&
    //             evt.Employee['EmployeeDepartment'] === EmployeeDepartment
    //         )
    //     })
    //     return filteredEvents
    // }
}

function updateDisplayRoster(cond, state) {}

function filterDisplayEventsByEmp(cond, events, state) {
    const { displayEmployees } = state

    const selected = _.find(displayEmployees, { EmployeeAutoID: cond })

    if (_.isEmpty(selected)) {
        return state.displayEvents
    } else {
        const filteredEvents = _.filter(events, function(evt) {
            return evt.EmployeeID === cond
        })

        return filteredEvents
    }
}

function filterDisplayEventsByEmployees(cond, events) {
    const { employees } = cond

    const filteredEvents = _.filter(events, function(evt) {
        const obj = _.find(employees, { code: evt.EmployeeID })

        return !_.isEmpty(obj)
    })

    return filteredEvents
}

function filterDisplayEvents(cond, state, selectedEmployees) {
    const { events, employeeList } = state
    const { branch, department, view } = cond

    let _employeeList = selectedEmployees || employeeList

    const workEvents = filterWorkAbsenceEvents(events, state, 'work')
    const absenceEvents = filterWorkAbsenceEvents(events, state, 'absence')

    if (branch === undefined && department === undefined) {
        if (view === 'work') {
            return workEvents.filteredEvents
        } else {
            return absenceEvents.filteredEvents
        }
    }

    if (view === 'work') {
        const filteredEvents = filterByBranchDepartment(
            workEvents.filteredEvents,
            _employeeList,
            branch,
            department
        )
        return filteredEvents
    } else {
        const filteredEvents = filterByBranchDepartment(
            absenceEvents.filteredEvents,
            _employeeList,
            branch,
            department
        )
        return filteredEvents
    }
}

function filterByBranchDepartment(events, employeeList, branch, department) {
    const filteredEvents = _.filter(events, function(evt) {
        const employee = _.find(employeeList, function(emp) {
            return emp.EmployeeAutoID === evt.EmployeeID
        })

        if (employee !== undefined) {
            const { EmployeeBranch, EmployeeDepartment } = employee

            if (branch !== undefined && department !== undefined) {
                return (
                    EmployeeBranch === branch &&
                    EmployeeDepartment === department
                )
            } else if (branch !== undefined && department === undefined) {
                return EmployeeBranch === branch
            } else if (branch === undefined && department !== undefined) {
                return EmployeeDepartment === department
            } else {
                return true
            }
        } else {
            return false
        }
    })

    return filteredEvents
}

function removeEvent(event, state) {
    return _.omit(state.events, event)
}

function addEvent(event, state) {
    return [...state.events, event]
}

/**
 *
 * @param {*} cond
 * @param {*} state
 */
function updateRptDisplayEvents(cond, state) {
    const { events } = state
    const { branch, department, view } = cond
    const actionType = NORMALWORKING_ACTION

    switch (view) {
        case reports.WEEKLY:
        case reports.DAILY: {
            const filteredEvents = _.filter(events, function(evt) {
                return evt.ActionType === actionType
            })
            return filterWithBranchDepart(branch, department, filteredEvents)
        }

        case reports.LEAVE:
            const filteredEvents = _.filter(events, function(evt) {
                return evt.ActionType !== actionType
            })
            return filterWithBranchDepart(branch, department, filteredEvents)
        case reports.SUMMARY:
            return filterWithBranchDepart(branch, department, events)
        default:
            return events
    }
}

function filterWithBranchDepart(branch, department, events) {
    // All branches and departments
    if (branch === undefined && department === undefined) {
        return events
    } else if (branch !== undefined && department === undefined) {
        const results = _.filter(events, function(evt) {
            return evt.Employee['EmployeeBranch'] === branch
        })
        return results
    } else if (branch === undefined && department !== undefined) {
        const results = _.filter(events, function(evt) {
            return evt.Employee['EmployeeDepartment'] === department
        })
        return results
    } else {
        const results = _.filter(events, function(evt) {
            return (
                evt.Employee['EmployeeBranch'] === branch &&
                evt.Employee['EmployeeDepartment'] === department
            )
        })
        return results
    }
}

/**
 *  transform events to graph data
 * @param {}} events
 */
function transformSummaryEvents(events, options) {
    const _workColor = 'hsl(215, 70%, 50%)'
    const _absenceColor = 'hsl(216, 70%, 50%)'

    const graphEvents = []
    const { time, range } = options

    const start = moment(time).startOf(range)
    const end = moment(time).endOf(range)

    const displayRange = dates.range(start, end)

    displayRange.map((date, j) => {
        const dateEvents = _.filter(events, function(evt) {
            const startOfDay = moment(date).startOf('day')

            const endOfDay = moment(date).endOf('day')

            return inRangeTest(
                moment(evt.start).toDate(),
                moment(evt.end).toDate(),
                startOfDay.toDate(),
                endOfDay.toDate()
            )
        })

        const dailySummary = _.countBy(dateEvents, function(evt) {
            return evt.ActionType === NORMALWORKING_ACTION ? 'work' : 'absence'
        })
        const dateLavel = moment(date).format('DD')

        graphEvents.push({
            date: dateLavel,
            work: dailySummary['work'] || 0,
            workColor: _workColor,
            absence: dailySummary['absence'] || 0,
            absenceColor: _absenceColor,
        })
    })

    return graphEvents
}

function inRangeTest(start, end, timeSlotStart, timeSlotEnd) {
    if (dates.lt(start, timeSlotStart)) {
        if (dates.lte(end, timeSlotStart)) {
            return false
        } else {
            return true
        }
    } else if (dates.gte(start, timeSlotEnd)) {
        return false
    } else {
        return true
    }
}
